import React from "react";
import { useStockOutputModel } from "../stockOutputModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "../../../base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export function PageHeader() {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const PageHeaderTitle = <>
        <span style={{ color: "#7F7F7F" }}>{Locale["Warehouse Management"]} </span>
        <span style={{ color: "#000" }}>/ {Locale["Stock Out"]}</span>
    </>
    const { getSelectedDictOne } = useDictModel();
    const { searchParam, updateSearchParam, resetSearchParam, loadData } = useStockOutputModel();
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            // placeholder: "出库单号",
            placeholder: Locale["Stock-out Doc No."],
            fieldName: "tradeCode"
        },
        {
            type: SearchTypeEnum.Select,
            // placeholder: "单据类型",
            placeholder: Locale["Document  Type"],
            fieldName: "tradeTypeCode",
            // options: getSelectedDictOne(DictCodeEnmu.TRADE_TYPE)
            options: getSelectedDictOne(DictCodeEnmu.TRADE_TYPE).filter(item => item.value === "trade-type.maintenance" || item.value === "trade-type.purchase-return" || item.value === "trade-type.sale")
        },
        {
            type: SearchTypeEnum.Input,
            // placeholder: "配件编码",
            placeholder: Locale["Material Code"],
            fieldName: "materialCode"
        },

    ]
    return (
        <YhPageHeader
            title={PageHeaderTitle}
            triggerSearch={true}
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    );
}